module.exports = __webpack_public_path__ + "static/media/switch-friend2.c32ee0f3.png";